import {animate, group, query, style, transition, trigger} from '@angular/animations';

export function createRouterTabGroupTransitionsFor(width: string) {
  return trigger('ROUTER_TAB_GROUP_TRANSITIONS', [
    transition(':decrement', [
      query(':enter, :leave', style({position: 'absolute', left: 0, width}), {optional: true}),
      group([
        query(':enter', [style({transform: 'translateX(-100%)'}), animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))], {optional: true}),
        query(':leave', [style({transform: 'translateX(0%)'}), animate('0.5s ease-in-out', style({transform: 'translateX(100%)'}))], {optional: true}),
      ])
    ]),
    transition(':increment', [
      group([
        query(':enter, :leave', style({position: 'absolute', left: 0, width}), {optional: true}),
        query(':enter', [style({transform: 'translateX(100%)'}), animate('0.5s ease-in-out', style({transform: 'translateX(0%)'}))], {optional: true}),
        query(':leave', [style({transform: 'translateX(0%)'}), animate('0.5s ease-in-out', style({transform: 'translateX(-100%)'}))], {optional: true}),
      ])
    ])
  ]);
}
